/**
 * This hook is used for returning the formatted price of the product unit
 */
import { useMemo } from 'react';
import { useContextParams } from '@core/params/context';
import { intlPrice } from '@core/shopping/utils/format';
/**
 *
 */
export const useProductUnitPrice = (props) => {
    const { unit, currency, modifierFn } = props;
    const locale = useContextParams()?.lang;
    const validOriginalPrice = unit &&
        typeof unit.unit_original_price === 'number' &&
        unit.unit_original_price > unit.unit_price;
    const unitPrice = unit && modifierFn ? modifierFn(unit?.unit_price) : unit?.unit_price;
    const unitOriginalPrice = validOriginalPrice
        ? unit.unit_original_price
        : unit && modifierFn
            ? unit?.unit_price
            : undefined;
    const unitPriceWithCurrency = useMemo(() => unitPrice
        ? intlPrice(unitPrice, currency, locale) ||
            unit?.unit_price_string ||
            ''
        : '', [currency, locale, unit, unitPrice]);
    const unitOriginalPriceWithCurrency = useMemo(() => unitOriginalPrice
        ? intlPrice(unitOriginalPrice, currency, locale) ||
            unit?.unit_original_price_string ||
            ''
        : '', [currency, locale, unit, unitOriginalPrice]);
    return {
        unitPrice,
        unitOriginalPrice,
        unitPriceWithCurrency,
        unitOriginalPriceWithCurrency,
    };
};
